import { all, call, put, takeLatest, select } from 'redux-saga/effects';
import { resolved } from 'store/createAction';
import {
  ARCHIVE_ALL_CONVERSATIONS,
  ARCHIVE_CONVERSATIONS,
  UPDATE_CONVERSATION,
  UPDATE_CONVERSATIONS,
  SEND_REPLY_MESSAGE,
} from './types';
import {
  getArchivedConversations,
  getConversations,
  getInboxes,
} from './actions';
import { selectSelectedInbox } from './selectors';

function* getArchivedConversationsSaga({ payload, meta }) {
  const inboxId = yield select(selectSelectedInbox);
  if (meta.status === '1') {
    yield put(
      getArchivedConversations(
        {
          limit: 30,
          offset: 0,
          inbox_id: inboxId,
        },
        true,
      ),
    );
  } else {
    yield put(
      getConversations(
        {
          limit: 30,
          offset: 0,
          inbox_id: inboxId,
        },
        true,
      ),
    );
  }
  yield put(getInboxes());
}

function* getUnreadCountSaga() {
  yield put(getInboxes());
}

export default function* root() {
  yield all([
    takeLatest(resolved(ARCHIVE_CONVERSATIONS), getUnreadCountSaga),
    takeLatest(resolved(UPDATE_CONVERSATION), getUnreadCountSaga),
    takeLatest(resolved(UPDATE_CONVERSATIONS), getUnreadCountSaga),
    takeLatest(resolved(SEND_REPLY_MESSAGE), getUnreadCountSaga),
    // takeLatest(
    //   resolved(ARCHIVE_ALL_CONVERSATIONS),
    //   getArchivedConversationsSaga,
    // ),
  ]);
}
